import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { Icon } from 'dlweb-components';
import { Menu } from 'antd';

const ContextMenu = (props) => {

  const [x, setX] = useState(0);
  const [y, setY] = useState(0);
  const [contextMenuHeight, setcontextMenuHeight] = useState('auto');

  const menuRef = useRef(null);

  const handleMenuClick = (e, item) => {
    props.$rootScope.$broadcast(item.action, item.data);
    props.handleClose();
  };

  useEffect(() => {
    const setCoordinates = () => {
      let x = props.coordinates.x;
      let y = props.coordinates.y;
      let menuHeight = menuRef.current.offsetHeight
      let menuWidth = menuRef.current.offsetWidth
  
      // Make sure menu isn't overflowing
      if(y + menuHeight > window.innerHeight) {
  
        if(menuHeight > window.innerHeight) {
          setcontextMenuHeight(window.innerHeight - 20 + 'px')
          menuHeight = window.innerHeight - 20;
        }
        
        let bottomOffset = y + menuHeight - window.innerHeight;
        bottomOffset += 10; // add a little padding
        
        y -= bottomOffset;
      }

      // if we don't have enough room to the right we open to the left
      // also add or remove a pixel so menu doesn't open under mouse
      if (x + menuWidth > window.innerWidth) {
        x -= menuWidth + 1;
      } else {
        x += 1;
      }
  
      setX(x);
      setY(y);
    }

    setCoordinates();
    
    const handleGlobalClick = (e) => {
      if(menuRef.current && !menuRef.current.contains(e.target)) {
        props.handleClose();
      }
    }

    document.addEventListener('click', handleGlobalClick, false);
    return () => {
      document.removeEventListener('click', handleGlobalClick, false);
    }
  }, [props])

  return(
    <div onContextMenu={e => e.preventDefault()}>
      <MenuContainer
        id="contextMenu"
        ref={menuRef}
        onClose={props.handleClose}
        x={x}
        y= {y}
        style={{overflow: 'auto', height: contextMenuHeight}}
      >
      {
        props.menuItems.map((itemArray, index) => {
          if(itemArray.length > 0) {
            return(
              <Menu
                style={{width: 300}}
                mode="inline"
                key={index}
              >

              {
                itemArray.map((item) => 
                  <Menu.Item
                    key={item.id}
                    style={{margin: '0px'}}
                    onClick={(e) => {handleMenuClick(e, item)}}
                  >
                    <Icon type={item.icon} fixedWidth="25px" />
                    <span style={{marginLeft: '10px'}}>{item.text}</span>
                  </Menu.Item>
                )
              }
              {index !== props.menuItems.length - 1 &&
                <Menu.Divider />
              }
              </Menu>

            )
          } else {
            return null;
          }
        })
      }
      </MenuContainer>
    </div>
  )
}

const MenuContainer = styled.div`
  position: absolute;
  top: ${props => props.y + 'px'};
  left: ${props => props.x + 'px'};
  text-align: left;
  background-color: #fff;
  z-index: 99999999;
  box-shadow: 0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12);
  opacity: 1;
  transform: scale(1, 1) translateZ(0px);
  transition: opacity 264ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 176ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  transform-origin: 0px 31px;
`

export default ContextMenu;